import { createContext } from 'react';
import { type UserInfo } from '@/types';

export type UserInfoContextType = {
  userInfo: UserInfo | null;
  userMetadata: string | null;
  isLoading: boolean;
  featuresChangedPending: boolean;
  setUserInfo: (userInfo: UserInfo | null) => void;
  setUserMetadata: (userMetadata: string | null) => void;
  dismissFeaturesChanged: () => void;
  checkForFeatureChanges: () => void;
};

export const UserInfoContext = createContext<UserInfoContextType>({
  userInfo: null,
  userMetadata: null,
  isLoading: true,
  featuresChangedPending: false,
  setUserInfo: () => {
    console.error('UserInfoContext is missing a provider.');
  },
  setUserMetadata: () => {
    console.error('UserInfoContext is missing a provider.');
  },
  dismissFeaturesChanged: () => {
    console.error('UserInfoContext is missing a provider.');
  },
  checkForFeatureChanges: () => {
    console.error('UserInfoContext is missing a provider.');
  },
});
